import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './WhyChooseCarRental.css'

const WhyChooseCarRental = () => {
  const services = [
    {
      title: "Flexible Rental Plans",
      description: "We create customized plans for our customers based on their needs, budget, and duration.  ",
      boxClass: "office",
      sectionClass: "first-section"
    },
    {
      title: "Diverse Fleet",
      description: "From hatchback cars to SUVs to luxury sedans, we have a range of cars that you can choose from.  ",
      boxClass: "phone",
      sectionClass: "second-section"
    },
    {
      title: "Flawless Booking",
      description: "To book your car, all you need to do is to contact our team, share your requirements, and voila! ",
      boxClass: "email",
      sectionClass: "third-section"
    },
    {
      title: "24x7 Support",
      description: "Our customer support team is available round the clock to ensure a smooth experience for you. ",
      boxClass: "website",
      sectionClass: "fourth-section"
    }
  ];

  return (
    <div>
      <>
        <div className="container ServiceOffering mb-0">
          <div className="row">
            <div className="col-md-12">
              <h1 className='headings text-center fs8'>
                <span>Why Choose</span> Our Car Rental Services?
              </h1>
            </div>
          </div>
        </div>
        <div className="offerings details-section">
          <div className="container mt-2 Car-Rental-Cards">
            <div className="row">
              {services.map((service, index) => (
                <div key={index} className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center padding">
                  <div className={`box1 ${service.boxClass}`}>
                    <div className="d-flex flex-column pb-4 mt-xxl-5 mt-md-4 pt-5">
                      <h4 className={`headings text-center ${service.sectionClass} position-relative zindex mt-3 pt-2 mt-md-3 mt-xxl-4 car-rental-box-title`}>
                        {service.title}
                      </h4>
                      <p className="text-center mt-1">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default WhyChooseCarRental;